import { render } from "./DriverDashboard.vue?vue&type=template&id=348e7849&scoped=true"
import script from "./DriverDashboard.vue?vue&type=script&lang=js"
export * from "./DriverDashboard.vue?vue&type=script&lang=js"

import "./DriverDashboard.vue?vue&type=style&index=0&id=348e7849&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348e7849"]])

export default __exports__